import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { AuthModalService } from 'src/shared/services/auth-modal.service';

@Injectable({
  providedIn: 'root'
})
export class GuestAccountGuard implements CanActivate {

  constructor(
    private storage: TidyStorage,
    private authModalService: AuthModalService
  ) {}

  async canActivate(): Promise<boolean> {
    const isGuestAccount = await this.storage.retrieve('isGuestAccount');
    if (!isGuestAccount) {
      return true;
    }
    await this.authModalService.openAuthModal('auth', 'signup', 'Create Account to Book');
    const stillGuest = await this.storage.retrieve('isGuestAccount');
    return !stillGuest;
  }
}
